export default __webpack_public_path__ + "static/seckelmann-0ae53a667c24df81fe5feca1e5b90eab.jpg";